import React from "react";
import "./HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard.scss";
import { StagesSVG } from "./StagesSvg";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";

export const ConstructionStages = (props) => {
  const { constructionStages } = props;
  const { selectedUserSuite } = useSelector((state) => state.userSuites);
  let localStatus = "Occupied";

  if (selectedUserSuite && selectedUserSuite.status != localStatus) {
    return (
      <div className="mainRow mt-40">
        <div className="card">
          <div className="card-header">Project Status</div>
          <div className="card-body">
            <div className="projectList">
              {constructionStages.map((cs) => {
                return (
                  <div className="projectInnner">
                    <div className="projectIcon">
                      <StagesSVG status={cs.statusName} />
                    </div>
                    <div className="projectContent">
                      <p className="projectContentSmall">{cs.statusName}</p>
                      <p className="projectContenthead">{cs.name}</p>
                      {!cs.date ||
                        (cs.date !== "0001-01-01T00:00:00+00:00" && (
                          <p className="projectContentSmall">
                            {moment(cs.date).format("MM/DD/YYYY")}
                          </p>
                        ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div className="mainRow mt-40"></div>;
  }
};
